import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-100 w-sm-350px",
  id: "kt-quick-links-menu",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "My Apps", -1)
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-light-primary me-n3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body py-5" }
const _hoisted_9 = { class: "mh-450px scroll-y me-n5 pe-5" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "fw-boldest" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
            ])
          ]),
          _createVNode(_component_Dropdown1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "row g-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.test && _ctx.test(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apps, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "col-4"
              }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.goByMyApp(i)),
                  class: "d-flex flex-column flex-center text-center text-gray-800 text-hover-primary bg-hover-light rounded p-3 mb-3"
                }, [
                  _createElementVNode("img", {
                    src: item.icon,
                    class: "w-25px h-25px mb-2",
                    alt: ""
                  }, null, 8, _hoisted_11),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.title), 1)
                ], 8, _hoisted_10)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}